module.exports = __webpack_public_path__ + "static/img/one.acf4f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/one.png
// module id = /0/F
// module chunks = 1